import TemplateDetailComponent from 'src/components/features/superAdmin/templateDetailComponent';

const DetailTemplatePage = () => <TemplateDetailComponent />;

export default DetailTemplatePage;
